import { NAVIGATE_TO_ITEM_PAGE, NAVIGATE_TO_OTHER_USER_PROFILE_PAGE, NAVIGATE_TO_PREMIUM_PLANS_PAGE } from "constants/events"

export const FOLLOW_REQUEST = "FOLLOW_REQUEST"
export const FOLLOW_ACCEPTED = "FOLLOW_ACCEPTED"
export const NEW_FOLLOWER = "NEW_FOLLOWER"
export const FOLLOWABLE = "FOLLOWABLE"
export const FOLLOWING = "FOLLOWING"
export const FOLLOW_REQUESTED = "FOLLOW_REQUESTED"
export const ITEM_LIKED = "ITEM_LIKED"
export const NEW_COMMENT = "NEW_COMMENT"
export const UPCOMING_BIRTHDAY = "UPCOMING_BIRTHDAY"
export const TRUE_WISH = "TRUE_WISH"
export const PREMIUM_EXPIRED = "PREMIUM_EXPIRED"
export const PREMIUM_EXPIRING = "PREMIUM_EXPIRING"

export const NOTIFICATIONS_MAP = {
  [FOLLOW_REQUEST]: {
    message: "notifications.followRequestMessage",
    onClickEvent: NAVIGATE_TO_OTHER_USER_PROFILE_PAGE
  },
  [FOLLOW_ACCEPTED]: {
    message: "notifications.followAcceptedMessage",
    onClickEvent: NAVIGATE_TO_OTHER_USER_PROFILE_PAGE
  },
  [NEW_FOLLOWER]: {
    message: "notifications.newFollowerMessage",
    onClickEvent: NAVIGATE_TO_OTHER_USER_PROFILE_PAGE
  },
  [ITEM_LIKED]: {
    message: "notifications.itemLikedMessage",
    onClickEvent: NAVIGATE_TO_ITEM_PAGE
  },
  [NEW_COMMENT]: {
    message: "notifications.newCommentMessage",
    onClickEvent: NAVIGATE_TO_ITEM_PAGE
  },
  [UPCOMING_BIRTHDAY]: {
    message: "notifications.upcomingBirthdayMessage",
    onClickEvent: NAVIGATE_TO_OTHER_USER_PROFILE_PAGE
  },
  [TRUE_WISH]: {
    message: "notifications.trueWishMessage",
    onClickEvent: NAVIGATE_TO_ITEM_PAGE
  },
  [PREMIUM_EXPIRED]: {
    message: "notifications.premiumExpiredMessage",
    onClickEvent: NAVIGATE_TO_PREMIUM_PLANS_PAGE
  },
  [PREMIUM_EXPIRING]: {
    message: "notifications.premiumExpiringMessage",
    onClickEvent: NAVIGATE_TO_PREMIUM_PLANS_PAGE
  }
} as const
